import React from "react";
import { navigate } from "gatsby";
import {FromatNumberVIE,FormatDateDMY} from "../../utils/format";
import {returnStatusOrder} from "../../helpers/general";


const OrderItem = (items)=>{
    const handleClickDetail=(id)=>{
        navigate('/account/orderdetail.html?'+id);
    }
  if(items.items.length > 0){
    return(
        <>
        {
            items.items.map((item,i)=>{
               return <tr key={i}>
                    <td scope="row"><strong><a onClick={()=>{handleClickDetail(item._id)}}>{item.sale??item.code}</a></strong></td>
                    <td>{FormatDateDMY(item.created)}</td>
                    <td>{
                        item.shipping?.type === 0 ? ("Giao hàng"):("Nhận tại cửa hàng")
                        }</td>
                    <td scope="row"><strong>{FromatNumberVIE(item.total)} đ</strong></td>
                    <td>{returnStatusOrder(item.status)}</td>
                    <td className="text-red" ><a onClick={()=>{handleClickDetail(item._id)}}>Xem đơn hàng</a></td>
                </tr>
            })
        }
        </>
    )
  }else{
    return null;
  }
}
export default OrderItem